import { Component, EventEmitter, Output, inject, Input, SimpleChanges } from '@angular/core';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { IComCategoryItem } from '../../../../../models/IComCategoryItem';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FavoritesItemsService } from '../../../../../services/favorites/favorites-items.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { faBookmark as faBookmarkSolid, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import { AuthService, LOGIN_TYPE_TOPBAR } from '../../../../../services/authentication/auth.service';
import { TimeLeftService } from '../../../../../services/time-left.service';
import { AbsoluteMediaUriService } from '../../../../../services/absolute-media-uri.service';
import { ButtonModule } from 'primeng/button';

interface ISanitizedItem {
  itemId?: number;
  imageUrl?: string;
  itemName?: string;
  currentLeadingBid?: number;
  currency?: string;
  orgName?: string;
  isFavorite?: boolean;
  estimatedValue?: number;
  buyNowPrice?: number;
  biddingType?: string;
  numberOfBids?: number;
  closingDate?: string;
  description?: string;
  orgCity?: string;
  orgState?: string;
  itemLocation?: string;
  itemParentLocation?: string;
  safeName?: string;
  isBiddable: boolean;
  isBuyable: boolean;
  openingDate?: string;
}

@Component({
  selector: 'app-main-items',
  standalone: true,
  imports: [RouterModule,
    CommonModule,
    IconFieldModule,
    InputIconModule,
    FontAwesomeModule,
    ProgressSpinnerModule,
    ButtonModule,
    CurrencyPipe],
  templateUrl: './main-items.component.html',
  styleUrl: './main-items.component.scss'
})
export class MainItemsComponent {
  @Input() items: IComCategoryItem[] = [];
  @Input() viewMode: 'image' | 'list' = 'image';
  @Input() isAuthenticated = false;
  @Input() category = 'Other';
  @Output() favoriteChanged = new EventEmitter<IComCategoryItem>();
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  private favoriteService = inject(FavoritesItemsService);
  private authService = inject(AuthService);
  timeLeftService = inject(TimeLeftService);

  faBookmarkSolid = faBookmarkSolid;
  faBookmarkRegular = faBookmarkRegular;
  faCreditCard = faCreditCard;
  sanitizedItems: ISanitizedItem[] = [];
  constructor(private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.sanitizedItems = this.items.map(((item: IComCategoryItem) => {
        return {
          itemId: item.itemId,
          imageUrl: item.imageUrl,
          itemName: item.itemName,
          currentLeadingBid: item.currentLeadingBid,
          currency: item.currency,
          orgName: item.orgName,
          isFavorite: item.isFavorite,
          estimatedValue: item.estimatedValue,
          buyNowPrice: item.buyNowPrice,
          biddingType: item.biddingType,
          numberOfBids: item.numberOfBids,
          closingDate: item.closingDate,
          openingDate: item.openingDate,
          description: item.description,
          orgCity: item.orgCity,
          orgState: item.orgState,
          itemLocation: item.itemLocation,
          itemParentLocation: item.itemParentLocation,
          isBiddable: item.isBiddable,
          isBuyable: item.isBuyable,
          safeName: this.sanitizeHtmlText(item.itemName!)
        };
      }) as any);
    }

    // console.log(this.sanitizedItems)
  }

  sanitizeHtmlText(content: string): SafeHtml {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const txt = document.createElement('textarea');
      txt.innerHTML = content;
      const decodedContent = txt.value;
      return this.sanitizer.bypassSecurityTrustHtml(decodedContent);
    }
    return '';
  }

  protected toggleFavorite(item: IComCategoryItem): void {
    // console.log(item.isFavorite);
    if (item.isFavorite) {
      this.removeItemFavorite(item);
    }
    else {
      this.itemFavorite(item);
    }
  }

  private itemFavorite(item: IComCategoryItem) {

    if (!this.isAuthenticated) {
      this.openLoginModalFavorite();
      return;
    }
    // console.log(item.id!)
    this.favoriteService.putFavorite(item.itemId!).subscribe({
      next: (reponse) => {
        // console.log('favorite responde', reponse)
        item.isFavorite = !item.isFavorite;
        this.favoriteChanged.emit(item);
      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    });
  }

  private removeItemFavorite(item: IComCategoryItem) {
    if (!this.isAuthenticated) {
      this.openLoginModalFavorite();
      return;
    }

    this.favoriteService.deleteFavorite(item.itemId!).subscribe({
      next: (reponse) => {
        // console.log('remove', reponse)
        item.isFavorite = !item.isFavorite;
        this.favoriteChanged.emit(item);
      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    });
  }

  private openLoginModalFavorite() {
    // TODO: Fix so don't need an AuctionId which is 0 for now
    this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, function () { }, 0);

  }

  isAmountEstimatedValue(value: string): boolean {
    const numeric = value.replace(/[^0-9.-]+/g, '');
    return numeric.trim() !== '' && !isNaN(Number(numeric));
  }


}
